//SECTION SUBHEADER - H3

import React from 'react'
import '../styles/header.css'


export default function SubHeader(props) {
    
    return(
    
        <div >
        
            <div class="row">
        
                <h3 class={props.styles}>{props.title}</h3>
        
            </div>
        
        </div> 
    
    );

}